<template>
  <NavigationBarTop />
  <h2 class="page-title"> Map Location and Contact </h2> 
      <section class="map-section">
        <h3 class="map-subtitle">📍 Map Us</h3>
        
        <div class="map-placeholder">
          <p>
            [**Google Maps Embed Code Here**]
            <br>
            *The map will appear once the iframe code is inserted.*
          </p>
        </div>
      </section>

    <FooterBarBelow />
      
</template>

<script>
import NavigationBarTop from '../components/NavigationBarTop.vue'
import FooterBarBelow from '../components/FooterBarBelow.vue'
export default {
    components: {
        NavigationBarTop,
        FooterBarBelow
    }
}
</script>

<style>
.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
}
.page-head {
    /* Style for the main h2 heading */
    font-size: 2rem;
    color: #1c1917;
    margin-top: 2rem;
    margin-bottom: 1rem;
    text-align: left; /* Ensure it stays left-aligned */
}

.map-section {
    margin-bottom: 3rem;
}

.map-subtitle {
    /* Indented H3 for the Map Title */
    font-size: 1.5rem;
    color: #333;
    font-weight: 600;
    margin-left: 1rem; /* Slightly indented */
    margin-bottom: 0.5rem;
}

.map-placeholder {
    /* Container for the Google Maps iframe */
    width: 100%;
    /* Sets the height for the map visual */
    height: 400px; 
    background-color: #eee;
    border: 1px solid #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #666;
    font-style: italic;
    overflow: hidden; /* Prevents iframe scrollbars if size is constrained */
}

/* Ensure the iframe (when added) fills the placeholder */
.map-placeholder > iframe {
    width: 100%;
    height: 100%;
    border: none;
}
</style>